import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Surface, TextBody } from '../../atoms';
export function RelationshipManagerCard({ email, name, phone }) {
    return (_jsxs(Surface, { variant: "tertiary", rounded: "md", style: $.container, children: [_jsx(TextBody, { color: "primary", small: true, lhFull: true, children: "Relationship manager" }), _jsx(TextBody, { mt: "6", em: true, lhFull: true, children: name }), _jsx(TextBody, { mt: "3", small: true, lhFull: true, href: `mailto:${email}`, children: email }), _jsx(TextBody, { mt: "2", small: true, lhFull: true, href: `tel:${phone}`, children: phone })] }));
}
const $ = StyleSheet.create({
    container: {
        padding: theme.spacing['4'],
    },
});
